export * from './assignment.service';
import { AssignmentService } from './assignment.service';
export * from './assignment.serviceInterface';
export * from './branch.service';
import { BranchService } from './branch.service';
export * from './branch.serviceInterface';
export * from './fleet.service';
import { FleetService } from './fleet.service';
export * from './fleet.serviceInterface';
export * from './masterdata.service';
import { MasterdataService } from './masterdata.service';
export * from './masterdata.serviceInterface';
export * from './planning.service';
import { PlanningService } from './planning.service';
export * from './planning.serviceInterface';
export * from './project.service';
import { ProjectService } from './project.service';
export * from './project.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export const APIS = [AssignmentService, BranchService, FleetService, MasterdataService, PlanningService, ProjectService, UserService];
